import React from 'react'
import { HeaderTitlePortal } from './RetailerScopeWrapper'

interface HeaderPortalProps {
  headerComponent: JSX.Element
}

export const HeaderPortal = ({ headerComponent }: HeaderPortalProps) => (
  <HeaderTitlePortal>{headerComponent}</HeaderTitlePortal>
)
